export const LOGIN_REMINDER_DEDUPE_KEY = "login_remind_popup";
export const LOGIN_REMINDER_DISMISSED_EVENT = "login-remind-popup-dismissed";

let dismissedForCurrentHomeEntry = false;

export const markLoginReminderDismissedForCurrentHomeEntry = (): void => {
  dismissedForCurrentHomeEntry = true;
};

export const resetLoginReminderDismissedForCurrentHomeEntry = (): void => {
  dismissedForCurrentHomeEntry = false;
};

export const isLoginReminderDismissedForCurrentHomeEntry = (): boolean =>
  dismissedForCurrentHomeEntry;

export const isLoginReminderHomePage = (pathname: string): boolean =>
  pathname === "/" || pathname.includes("/home");

interface ShouldEnqueueLoginReminderArgs {
  isLogin: boolean;
  pathname: string;
  dismissedOnCurrentHomeEntry: boolean;
  hasPendingLoginReminder: boolean;
}

export const shouldEnqueueLoginReminder = ({
  isLogin,
  pathname,
  dismissedOnCurrentHomeEntry,
  hasPendingLoginReminder,
}: ShouldEnqueueLoginReminderArgs): boolean => {
  if (isLogin) return false;
  if (!isLoginReminderHomePage(pathname)) return false;
  if (dismissedOnCurrentHomeEntry) return false;
  if (hasPendingLoginReminder) return false;
  return true;
};
